import React from "react";
import {
  Box,
  DialogContent,
  Typography,
  Divider,
  Dialog,
  DialogActions,
  Theme,
  DialogTitle
} from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { useTranslation } from "react-i18next";
import AudioInputList from "./AudioInputList/AudioInputList";
import AudioOutputList from "./AudioOutputList/AudioOutputList";
import VideoInputList from "./VideoInputList/VideoInputList";
import { typography } from "../../../utils/typography";
import { semanticColors } from "../../../utils/colors";

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    width: "600px",
    minHeight: "400px",
    [theme.breakpoints.down("sm")]: {
      width: "calc(100vw - 32px)"
    },
    "& .inputSelect": {
      width: "calc(100% - 35px)"
    }
  },
  paper: {
    [theme.breakpoints.down("sm")]: {
      margin: "16px"
    },
    borderRadius: "16px !important"
  },
  listSection: {
    margin: "2em 0 0.8em",
    "&:first-child": {
      margin: "1em 0 2em 0"
    }
  }
}));

export default function DeviceSelectionDialog({
  open,
  onClose
}: {
  open: boolean;
  onClose: () => void;
}) {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <Dialog open={open} onClose={onClose} classes={{ paper: classes.paper }}>
      <DialogTitle
        sx={{ ...typography.heading.s, color: semanticColors.text.primary }}
      >
        {t("settings.audioVideo")}
      </DialogTitle>
      <Divider />
      <DialogContent className={classes.container}>
        <div className={classes.listSection}>
          <Typography
            sx={{
              ...typography.body.lSemibold,
              color: semanticColors.text.primary,
              mb: "1em"
            }}
          >
            {t("settings.video")}
          </Typography>
          <VideoInputList />
        </div>
        <Divider />
        <div className={classes.listSection}>
          <Typography
            sx={{
              ...typography.body.lSemibold,
              color: semanticColors.text.primary,
              mb: "1em"
            }}
          >
            {t("settings.audio")}
          </Typography>
          <AudioInputList />
        </div>
        <div className={classes.listSection}>
          <AudioOutputList />
        </div>
      </DialogContent>
      <DialogActions sx={{ px: 3, py: 2 }}>
        <Box
          component="button"
          onClick={onClose}
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            background: semanticColors.gradient.surface,
            borderRadius: "40px",
            height: "44px",
            border: "none",
            cursor: "pointer",
            px: "24px"
          }}
        >
          <Typography
            sx={{
              ...typography.body.lBold,
              color: semanticColors.text.inverse
            }}
          >
            {t("settings.submit")}
          </Typography>
        </Box>
      </DialogActions>
    </Dialog>
  );
}
